var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 24.617H13.5a2.252 2.252 0 0 1-2.25-2.25v-4.5a2.252 2.252 0 0 1 2.25-2.25h6.75a2.252 2.252 0 0 1 2.25 2.25v4.5a2.252 2.252 0 0 1-2.25 2.25zm-6.75-6.75v4.5h6.75v-4.5H13.5z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18.992H6.75v-5.625A2.252 2.252 0 0 1 9 11.117h6.75v2.25H9v5.625z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 34.742c-.2 0-.395-.052-.567-.152l-13.5-7.876A1.125 1.125 0 0 1 0 25.744V9.992a1.125 1.125 0 0 1 .558-.972l13.5-7.875a1.125 1.125 0 0 1 1.134 0l13.5 7.875-1.134 1.943L14.625 3.42 2.25 10.638v14.459l12.375 7.219L27 25.096v-8.354h2.25v9a1.125 1.125 0 0 1-.558.973l-13.5 7.875c-.172.1-.368.153-.567.152z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.fafb9245ad714eced0decfbe23838179.svg";
export { ForwardRef as ReactComponent };